import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const formatToLocalDate = (data: any, format: string) => {
  return dayjs(data).isValid() ? dayjs.utc(data).local().format(format) : data;
};
